import Vue from "vue";
import VueRouter from "vue-router";
import homePage from "../views/homePage.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "",
    name: "homePage",
    component: () => import("../views/homePage"),
    children: [
      { path: "/", name: "home" },
      { path: "gallery", name: "gallery" },
      { path: "catalog", name: "catalog" },
      { path: "virtual-tour", name: "virtual_tour" },
      { path: "comments", name: "comments" },
      { path: "about-us", name: "aboutus" },
      { path: "feature", name: "feature" },
      {
        path: "/order",
        name: "order",
        beforeEnter() {
          location.href = "https://sdfn.ir/f/namya/view.php?id=30367";
        },
      },
    ],
    props: true,
    beforeLeave: (to, from, next) => {
      localStorage.removeItem("token");
      next();
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
